/* eslint-disable import/no-anonymous-default-export */
import paymentPage from "./payment-page.json"
import recapPage from "./recap-page.json"

export default {
  "payment-page": paymentPage,
  "recap-page": recapPage,
}
